import React from 'react'
import { Row, Col } from 'react-bootstrap'
import {allIndustryCodes} from '../../../../../resources/industry-codes.json'
import DashboardNewListIndustryCodeRow from './table-row'

import './style.scss'

const Index = () => {
	return(
		<div>
			<div className="tab-content-container">
				<div className="all-industries-container">
					<Row className="upper-information-row">
						<Col className="title-col">
							<h3>Navn</h3>
						</Col>
						<Col className="code-col text-center">
							<h3>Kode</h3>
						</Col>
						<Col className="arrow-col text-right">
							<h3>Vis mer</h3>
						</Col>
					</Row>
					{Object.keys(allIndustryCodes).map((rootItem, firstIndex, firstArr) => {
          				return(
            				<DashboardNewListIndustryCodeRow singleIndustry={allIndustryCodes[rootItem]}/>
            			)
          			})}
				</div>
			</div>
		</div>
	)
}

export default Index